import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../components/ui/accordion";
import useReveal from "../hooks/useReveal";

const FAQS = [
    {
        q: "What does WE DELVR LOGISTICS actually do?",
        a: "We help Australian importers and exporters take control of freight cost, shipment visibility and supply chain performance. We combine independent advisory with a forthcoming digital platform that connects your forwarders, carriers and finance data in one place — so you can plan better, control execution, and audit cost after every shipment.",
    },
    {
        q: "Are you a freight forwarder?",
        a: "No. We're independent of carriers and forwarders, which means our advice is impartial. We work alongside your existing forwarders or help you select better ones — we don't sell freight ourselves.",
    },
    {
        q: "When does the product platform launch?",
        a: "We're in early access now. Join the list and you'll be among the first to onboard, with priority pricing and influence over the feature roadmap. Early-access members also receive a free freight cost diagnostic.",
    },
    {
        q: "Which AU ports and modes do you cover?",
        a: "We support all major Australian ports — Sydney, Melbourne, Brisbane, Fremantle and Adelaide — across sea, air, road and intermodal freight. Customs and inland leg are included.",
    },
    {
        q: "How does pricing work?",
        a: "Advisory engagements are scoped per project. The platform will launch on a subscription model with tiers based on shipment volume. Early-access members lock in launch pricing for 12 months.",
    },
    {
        q: "Can you track containers from forwarders I already use?",
        a: "Yes. Our tracking layer is forwarder-agnostic — give us a container number or connect a feed and we surface a unified live view across every leg, every carrier.",
    },
    {
        q: "Do you handle customs clearance?",
        a: "Customs brokerage is delivered through licensed partner brokers we curate. We orchestrate documentation, compliance checks and clearance status inside the same workflow as the shipment.",
    },
    {
        q: "How do you handle our commercial and shipment data?",
        a: "Data is stored encrypted at rest, isolated per customer and never resold. We sign NDAs as standard and align to Australian Privacy Principles. Detailed security documentation is provided on request.",
    },
];

export default function FAQ() {
    const [ref, visible] = useReveal();
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative border-t border-white/5 py-20 sm:py-28"
        >
            <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} max-w-5xl mx-auto px-4 sm:px-6 lg:px-8`}>
                <div className="text-center mb-12">
                    <span className="section-tag">FAQ</span>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white mt-5 leading-tight">
                        Frequently asked questions.
                    </h2>
                </div>

                <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                    {FAQS.map((f, idx) => (
                        <AccordionItem
                            key={idx}
                            value={`item-${idx}`}
                            className="border-b border-white/10"
                            data-testid={`faq-item-${idx}`}
                        >
                            <AccordionTrigger className="text-left font-display text-base sm:text-lg text-white py-5 hover:text-cyan-300 hover:no-underline">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-zinc-400 leading-relaxed text-sm sm:text-base pb-6">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
